import React from 'react';
import { AppIcon } from '../../../../components/icons/AppIcon';
import { ChatAttachMenu } from './ChatAttachMenu';

interface ChatInputActionsProps {
    chatPlatform?: 'whatsapp' | 'instagram';
    isRecording: boolean;
    toggleEmojiPicker: () => void;
    showEmojiPicker: boolean;
    emojiButtonRef: React.RefObject<HTMLButtonElement>;
    mediaInputRef: React.RefObject<HTMLInputElement>;
    documentInputRef: React.RefObject<HTMLInputElement>;
    onMediaChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onDocumentChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onOpenContact: () => void;
    onOpenPix: () => void;
    onOpenLocation: () => void;
}

export const ChatInputActions: React.FC<ChatInputActionsProps> = ({
    chatPlatform = 'whatsapp',
    isRecording,
    toggleEmojiPicker,
    showEmojiPicker,
    emojiButtonRef,
    mediaInputRef,
    documentInputRef,
    onMediaChange,
    onDocumentChange,
    onOpenContact,
    onOpenPix,
    onOpenLocation,
}) => {
    if (isRecording) return null;

    return (
        <div className="chat-composer__actions pl-s1">
            <ChatAttachMenu
                chatPlatform={chatPlatform}
                mediaInputRef={mediaInputRef}
                documentInputRef={documentInputRef}
                onMediaChange={onMediaChange}
                onDocumentChange={onDocumentChange}
                onOpenContact={onOpenContact}
                onOpenPix={onOpenPix}
                onOpenLocation={onOpenLocation}
            />
            <button
                ref={emojiButtonRef}
                type="button"
                onClick={toggleEmojiPicker}
                className={`chat-composer__icon ${showEmojiPicker ? 'chat-composer__icon--active' : ''}`}
                title="Emojis"
            >
                <AppIcon name="smile" className="size-[18px]" aria-hidden />
            </button>
        </div>
    );
};
